module.exports = __webpack_public_path__ + "img/Icon-Catalogue.3cf2943a.svg";